// Български - bg - 保加利亚语
const bg = {
  home: {
    home: 'Начало',
    solutions: 'Решения',
    support: 'Поддръжка',
    news: 'Новини',
    aboutUs: 'За нас',
    contactUs: 'Контакт',
    cgm: 'CGM',
    download: 'Изтегляния',
    helpCenter: 'Център за помощ',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Всички права запазени.',
    menu: 'Меню',
    quickLinks: 'Бързи връзки',
    contact: 'Контакт',
    legal: 'Правна информация',
    termsUse: 'Условия за ползване',
    privacyPolicy: 'Политика за поверителност',
    portal: 'Портал на потребителя',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'Имейл',
    subscribe: 'Абониране',
    signUp: 'Регистрирайте се за най-новите новини',
    downloadApp: 'Изтеглете приложението',
    blogNews: 'Блог и новини',
    latestArticles: 'Последни статии',
    viewAllArticles: 'Виж всички статии',
    empower: 'Поемете контрола над здравето си заедно с нас',
    empowerList1Content:
      'Hippo CGM направи управлението на диабета на сина ми много по-лесно. Можем да използваме HIPPOLINK, за да виждаме ясно моделите на неговата глюкоза и да коригираме грижите с увереност. Това ни дава спокойствие.',
    empowerList1Name: 'Petra N., Чехия (майка на дете с диабет тип 1)',
    empowerList2Content:
      'Препоръчваме Hippo CGM на нашите пациенти заради неговата стабилна работа и по-дългото време на носене. Отзивите от потребителите са отлични, особено от тези, които търсят по-достъпна опция.',
    empowerList2Name: 'Д-р Лука Б., ендокринолог, Италия',
    empowerList3Content:
      'Започнах да използвам Hippo CGM наскоро — удобен е, точен, а алармите ми помогнаха да избегна ниска кръвна захар през нощта. Много съм доволен от резултатите до момента.',
    empowerList3Name: 'Fahad A., Саудитска Арабия (пациент с диабет тип 2)',
    reliable: 'Вашият надежден партньор за управление на диабета',
    hippoH1: 'HiPPO H1',
    challenges: 'Предизвикателства',
    constant: 'Постоянно наблюдение на кръвната захар',
    traditional: 'Традиционното убождане на пръст може да бъде болезнено',
    dataOverload: 'Претоварване с данни',
    managing:
      'Управлението на данни за кръвната захар от множество източници може да бъде изтощително и трудно за интерпретиране.',
    treatment: 'Корекции на лечението',
    accurately: 'Точното определяне на подхода може да бъде сложно',
    lifestyle: 'Интеграция в начина на живот',
    balancing:
      'Баланс между храна, движение и лекарства може да бъде предизвикателство',
    hippoCan: 'Hippo биосензорите предлагат',
    painless: 'Безболезнено и дискретно наблюдение',
    ourCgm:
      'Нашият CGM осигурява непрекъснато измерване без нуждата от убождане',
    realTime: 'Данни и анализ в реално време',
    accessYour:
      'Вижте данните за кръвната си захар удобно от вашия смартфон, което ви позволява да виждате тенденциите и да вземате информирани решения.',
    personalized: 'Персонализирана поддръжка',
    ourCgmSys:
      'Алармите и напомнянията от приложението Hippo H1 ви помaгат да следвате стриктно вашия план за лечение.',
    improved: 'По-добро вземане на решения',
    gain: 'По-доброто разбиране за това как тялото ви реагира на различни събития ви дава възможност да компенсирате по-добре колебанията в глюкозата. Обратната връзка в реално време ви позволява да правите корекции в ежедневните си дейности по-ефективно.',
    // about: 'Despre',
    companyProfile: 'Профил на компанията',
    banner1Title: 'Добре дошли в Hippo Medical',
    banner1Content: 'Начело на иновациите в CGM',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Поставяме нови стандарти в CGM технологиите',
    banner3Content: 'Денонощна защита на глюкозата.',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Лидер в CGM технологията',
    // 错误提示
    subscribeSuccess: 'Абонирането е успешно', // ai翻译
    subscribeFailed: 'Абонирането е неуспешно', // ai翻译
    invalidEmail: 'Невалиден имейл адрес', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return bg.home.banner1Title;
    },
    get banner1Content() {
      return bg.home.banner4Content;
    },
    whyChoose: 'Защо да изберете HiPPO CGM',
    accurate: 'Точност, на която можете да се доверите',
    accurateText: 'Трето поколение ензимна технология осигурява',
    accurateText1: 'по-стабилна и точна работа',
    easyUse: 'Лесен за използване',
    easyUseText: '14 дни непрекъснато наблюдение',
    realTime: 'Наблюдение',
    realTimeText: 'Известия за хипо- и хипергликемия в реално време',
    realTimeText1: 'Споделяне на данни в реално време',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Информира ви навсякъде и по всяко време',
    withHippo: 'С HiPPO приложения и портал',
    smallSensors: 'Малки сензори, удобни за носене',
    agpReport:
      'Професионалният AGP отчет позволява на медицинските специалисти и потребителите да уловят ключовата информация незабавно',
    unlimitedFollow:
      'Неограничено проследяване на пациенти, което дава възможност на медицинските специалисти да управляват повече потребители.',
    iWatchApp: 'Налично приложение за iWatch',
    certified: 'Сертифициран за деца',
    loremIp:
      'Системата е клинично валидирана и официално сертифицирана за педиатрична употреба при деца над 3-годишна възраст, гарантирайки безопасност, точност и комфорт за младите пациенти. С доказана прецизност на сензора и нежни, щадящи кожата материали, тя осигурява надежден мониторинг на глюкозата за деца и юноши — подкрепяйки медицинските специалисти в предоставянето на уверена и базирана на данни грижа за диабета.',
  },
  news: {
    date: 'Дата',
    recommendedArticles: 'Препоръчани статии',
  },
  support: {
    download: 'Изтегляне на ръководства',
    supportDown: 'Поддръжка/Изтегляния',
  },
  about: {
    // welcome: 'Bine ați venit la Hippo Medical',
    // covered: 'Țări acoperite',
    // patents: 'Brevete',
    // features: 'Caracteristici3',
    // ring: 'Inel',
    // apparently:
    // 'Un inel misterios care poate monitoriza parametri precum oxigenul din sânge, ritmul cardiac și somnul. Mai important, are o conexiune algoritmică cu senzorul  (CGM ) nostru. Lansare în 2026. Rămâneți aproape!',
    // cgmSky:
    //   'Un senzor ( CGM ) profesional conceput atât pentru utilizarea de către pacienți, cât și pentru nevoile clinice ale medicilor. Oferă precizie ridicată, un software ușor de utilizat și este alimentat de algoritmii Hippo Medical. Lansat în iunie 2025!',
    // smartWatch: 'Ceas inteligent',
    // byTheSame:
    //   'Un dispozitiv purtabil de monitorizare dinamică a tensiunii arteriale care poate urmări continuu presiunea sistolică, presiunea diastolică, presiunea arterială medie și altele, cu un algoritm dezvoltat de Hippo Medical. Lansare în 2026. Rămâneți aproape!',
    explore: 'Разгледайте',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'СИНГАПУР (409051)',
    zipCode: 'Пощенски код',
    emailCode: '409051',
    email: 'Имейл',
    emailText: 'info@hippodiabetes.com',
    name: 'Име',
    company: 'Компания',
    message: 'Съобщение',
    phone: 'Телефон',
    submit: 'Изпрати',
    // commingSoon: 'În curând',
    cpInfo1:
      'Hippo Medical is a global MedTech company, headquartered in Singapore, dedicated to revolutionizing chronic disease management with medical-grade wearable biosensors. Our vision is to provide continuous monitoring and advanced data analysis.',
    cpInfo2:
      'Чрез разработването на биосензори от следващо поколение и авангардна платформа за интелигентен анализ на данни, ние се стремим да трансформираме диагностиката и да проправим пътя към едно по-проактивно и персонализирано бъдеще.',
    submitFailed: 'Изпращането е неуспешно', // ai翻译
    get invalidEmail() {
      return bg.home.invalidEmail;
    },
    fillAllFields: 'Моля, попълнете това поле', // ai翻译
  },
  download: {
    language: 'Език',
    product: 'Продукт',
    unit: 'Единица',
    fetchFailed: 'Неуспешно извличане', // ai翻译
  },
  help: {
    search: 'Търсене',
    support: 'Поддръжка/Център за помощ/H1 CGM',
    source: 'Онлайн ресурси HiPPO H1 CGM',
    viewAll: 'Виж всички',
    insert: 'Как да поставите H1 CGM',
    setUp: 'Как да настроите приложението H1',
    faq: 'Често задавани въпроси H1 CGM',
    freq: 'Често задавани въпроси',
    noData: 'Не е намерено съдържание..',
    searchKeys: {
      warmUp: 'Грешка при загряване',
      waterLeakage: 'Теч на вода',
      lowGlucose: 'Данни за ниска кръвна захар',
      cannotPair: 'Не може да се свърже със смартфон',
    },
  },
  faq: {
    faq: 'Често задавани въпроси',
    general: 'Общи въпроси',
    need: 'Нуждаете се от помощ?',
    here: 'Ето най-често задаваните въпроси',
    technical: 'Технически въпроси',
  },
  lang: {
    chooseCountry: 'Изберете държава/регион',
    northAmerica: 'Северна Америка', // ai翻译
    southAmerica: 'Южна Америка', // ai翻译
    europe: 'Европа', // ai翻译
    africa: 'Африка', // ai翻译
    asia: 'Азия', // ai翻译
    oceania: 'Океания', // ai翻译
    other: 'Други', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Сужоу, Китай',
      subName: 'Производствена база',
      hovData: 'Глобален HQ R&D/център за данни/офис продажби Азия и Австралия',
    },
    dubai: {
      name: 'Дубай',
      subName: 'Регионален офис',
      hovData: 'Екип продажби Югоизточна Азия',
    },
    singapore: {
      name: 'Сингапур',
      subName: 'Седалище',
      hovData: 'Екип продажби Югоизточна Азия',
    },
    sanFrancisco: {
      name: 'Сан Франциско, САЩ',
      subName: 'Регионален офис',
      hovData: 'Екип продажби Северна Америка',
    },
    barcelona: {
      name: 'Барселона',
      subName: 'Офис продажби',
      hovData: 'Глобален HQ R&D/център за данни/офис продажби Азия и Австралия',
    },
  },
};
export default bg;
